/**
 * 文件大小格式化（Issue #198）。
 *
 * 后端把 declaredByteSize 表示为字符串以避免 BigInt 精度丢失；此处仅
 * 把字符串安全地转换为可读单位。展示用，不参与上传校验。
 */

const UNITS: readonly { limit: number; suffix: string; divisor: number }[] = [
  { limit: 1024, suffix: 'B', divisor: 1 },
  { limit: 1024 * 1024, suffix: 'KB', divisor: 1024 },
  { limit: 1024 * 1024 * 1024, suffix: 'MB', divisor: 1024 * 1024 },
  { limit: Infinity, suffix: 'GB', divisor: 1024 * 1024 * 1024 },
];

export function formatByteSize(byteSize: string | number | null | undefined): string {
  if (byteSize === null || byteSize === undefined) return '';
  const n = typeof byteSize === 'number' ? byteSize : Number(byteSize);
  if (!Number.isFinite(n) || n < 0) return '';
  const unit = UNITS.find((u) => n < u.limit) ?? UNITS[UNITS.length - 1]!;
  const value = n / unit.divisor;
  return `${value < 10 && unit.suffix !== 'B' ? value.toFixed(1) : Math.round(value)} ${unit.suffix}`;
}
